export const layoutBreakpoint = {
  lg: 1280,
  md: 960,
  sm: 767,
  xs: 600,
};
